// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"181382d3","431":"3bcca8ec","787":"9f90e856"}[chunkId] + ".chunk.js";
};